import * as _ from 'lodash';
import nvSdcModule from '../../../../nv.sdcModule.module';
import { ISorterColumn } from './../../../../../shared/sorter-column/sorter-column.service';

interface IColumnMap {
  humanName: string;
  machineName: string;
}

export class GridColumnAutoCompleteCtrl {
  static $inject = ['$scope', 'SorterColumn'];

  mdDelay = 1;
  mdNoCache = true;
  mdIsDisabled = false;
  mdMinLength = 0;
  mdSearchText = null;
  mdSelectedItem = null;
  inputIsDisabled = true;
  availableColumns: IColumnMap[];
  pickerOptions = [];
  private allSelectedCols;

  constructor(private $scope, private SorterColumn) {
    const allColumnKeys: string[] = this.SorterColumn.getSorterColumnKeys();
    this.availableColumns = allColumnKeys.map(key => {
      const sorterCol: ISorterColumn = SorterColumn.getByColumnKey(key);
      return {
        humanName: sorterCol.humanName,
        machineName: key,
      };
    });
  }

  selectedItemChange(col) {
    if (!col) return;
    // TODO: remove scope. Instead pass down callback for updating column selection.
    this.allSelectedCols.push(col.machineName);
  }

  _createFilterFor(query) {
    return function filterFn(item) {
      const thisItem = item.humanName.toLowerCase();
      const searchItem = query.toLowerCase();
      return _.includes(thisItem, searchItem);
    };
  }

  onSearchTextChange(searchText) {
    let results;
    // if query string exists, create the filtered and assign. If NO query string, just return all the columns
    if (searchText) {
      const filterFunc = this._createFilterFor(searchText);
      results = _.filter(this.availableColumns, filterFunc);
    } else {
      results = this.availableColumns;
    }
    results = _.sortBy(results, ['humanName']);
    return results;
  }
}

angular.module(nvSdcModule).controller('gridColumnAutoCompleteCtrl', GridColumnAutoCompleteCtrl);
